import React from "react";
import {TextField} from "@mui/material";
import { withTranslation, WithTranslation } from 'react-i18next';

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    onUsernameChange: (id: string) => void;
}

/**
 * Component allowing a user to fill in his username.
 * Returns it to the parent component.
 * @author Alizée Grand
 * @version 1.1
 * @creation 15/04/2021
 * @last_update 11/07/2022
 **/
class InputUsername extends React.Component<Props> {

    render() {

        /**
        * Retrieves from the props the function to access the translation.
        **/
        const getTranslation = this.props.t;

        /**
         * When the user fills the field, send it back to the parent component
         * @param event
         */
        const onUsernameChange = (event: any) => {
            const id = event.target.value!;
            if(id) {
                this.props.onUsernameChange(id);
            }
        };

        /**
         * An object containing a style that changes the colour of a text.
         * @type {{style: {color: string}}}
         */
        const propsStyle = {
            style: {
                color: 'rgba(255,255,255,0.7)',
            },
        };

        return (
            <TextField
                type="text"
                onChange={e => {onUsernameChange(e)}}
                label={getTranslation('pages.connection.input.label')}
                color="secondary"
                helperText={getTranslation('pages.connection.input.hint')}
                margin="dense"
                fullWidth={true}
                variant="outlined"
                placeholder="A087RF14FD98ARFSS"
                InputProps={propsStyle}
                InputLabelProps={propsStyle}
                FormHelperTextProps={propsStyle}
                focused
                autoFocus
            />
        );
    }
}

export default withTranslation()(InputUsername);
